'use client';

import React from 'react';
import { Package, Ship, Factory, Cog } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedCategory } from "../redux/slices/appSlice";

const imageCategories = [
    {
        id: 'module',
        name: 'Module',
    },
    {
        id: 'shipping1',
        name: 'Ship Line 1',
    },
    {
        id: 'shipping2',
        name: 'Ship Line 2',
    },
    {
        id: 'hmgma',
        name: 'HMGMA',
    }
];

const ImageCategorySelector = () => {
    const dispatch = useDispatch();
    const selectedCategory = useSelector(state => state.app.selectedCategory) ?? 'module'

    const getCategoryIcon = categoryId => {
        switch (categoryId) {
            case 'module':
                return <Cog className="h-6 w-6" />;
            case 'shipping1':
                return <Ship className="h-6 w-6" />;
            case 'shipping2':
                return <Ship className="h-6 w-6" />;
            case 'hmgma':
                return <Factory className="h-6 w-6" />;
            default:
                return <Package className="h-6 w-6" />;
        }
    };

    const getCategoryColor = (categoryId, isSelected) => {
        const colors = {
            module: isSelected ? 'bg-blue-50 border-blue-500 text-blue-900' : 'border-gray-200 hover:border-blue-300',
            shipping1: isSelected ? 'bg-green-50 border-green-500 text-green-900' : 'border-gray-200 hover:border-green-300',
            shipping2: isSelected ? 'bg-purple-50 border-purple-500 text-purple-900' : 'border-gray-200 hover:border-purple-300',
            hmgma: isSelected ? 'bg-orange-50 border-orange-500 text-orange-900' : 'border-gray-200 hover:border-orange-300'
        };
        return colors[categoryId];
    };

    const getIconColor = (categoryId, isSelected) => {
        const colors = {
            module: isSelected ? 'text-blue-600' : 'text-blue-500',
            shipping1: isSelected ? 'text-green-600' : 'text-green-500',
            shipping2: isSelected ? 'text-purple-600' : 'text-purple-500',
            hmgma: isSelected ? 'text-orange-600' : 'text-orange-500'
        };
        return colors[categoryId];
    };

    return (
        <div className="production-card">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Monitoring Categories</h3>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {imageCategories.map((category) => {
                    const isSelected = selectedCategory === category.id;

                    return (
                        <button
                            key={category.id}
                            onClick={() => dispatch(setSelectedCategory({ selectedCategory: category.id }))}
                            className={`
                          relative p-3 sm:p-4 rounded-lg border-2 transition-all duration-200 text-left w-full
                          ${isSelected
                                    ? getCategoryColor(category.id, true) + ' shadow-md'
                                    : 'border-gray-200 bg-white hover:shadow-sm ' + getCategoryColor(category.id, false)
                                }
                        `}
                        >
                            <div className="flex items-center justify-between mb-2">
                                <div className={`p-1.5 sm:p-2 rounded-lg ${isSelected ? 'bg-white bg-opacity-80' : 'bg-gray-100'}`}>
                                    <div className={getIconColor(category.id, isSelected)}>
                                        {getCategoryIcon(category.id)}
                                    </div>
                                </div>

                                {isSelected && (
                                    <div className="w-2 h-2 bg-current rounded-full"></div>
                                )}
                            </div>

                            <h4 className={`font-semibold mb-1 text-[clamp(0.5rem,2.6vw,1.2rem)] ${isSelected ? '' : 'text-gray-900'}`}>
                                {category.name}
                            </h4>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default ImageCategorySelector;
export { imageCategories }; 